"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _excluded = ["unique"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var propTypes = {
  unique: _propTypes.string
};

var FastForward = function FastForward(_ref) {
  var _ref$unique = _ref.unique,
      unique = _ref$unique === void 0 ? "" : _ref$unique,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("defs", {
    fill: "inherit"
  }), /*#__PURE__*/_react["default"].createElement("g", {
    fill: "inherit",
    fillRule: "evenodd",
    id: "glyphs/av/fast_forward-fast-forward" + unique,
    stroke: "none",
    strokeWidth: 1
  }, /*#__PURE__*/_react["default"].createElement("use", {
    fill: "inherit",
    id: "combined-shape-fast-forward" + unique,
    xlinkHref: "#path-1-fast-forward" + unique
  }), /*#__PURE__*/_react["default"].createElement("g", {
    fill: "inherit",
    id: "colors/core/gunmetal-fast-forward" + unique
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M2.86278445,3.1904804 L10.9129922,11.6784328 C11.0963074,11.8717162 11.0958959,12.1747817 10.9120563,12.3675664 L2.86184858,20.8094779 C2.67127784,21.0093214 2.3547846,21.0168384 2.15494115,20.8262676 C2.05599185,20.7319096 2,20.6011466 2,20.4644191 L2,3.53455516 C2,3.25841278 2.22385763,3.03455516 2.5,3.03455516 C2.63719929,3.03455516 2.76837083,3.09093286 2.86278445,3.1904804 Z M13.8627845,3.1904804 L21.9129922,11.6784328 C22.0963074,11.8717162 22.0958959,12.1747817 21.9120563,12.3675664 L13.8618486,20.8094779 C13.6712778,21.0093214 13.3547846,21.0168384 13.1549412,20.8262676 C13.0559919,20.7319096 13,20.6011466 13,20.4644191 L13,3.53455516 C13,3.25841278 13.2238576,3.03455516 13.5,3.03455516 C13.6371993,3.03455516 13.7683708,3.09093286 13.8627845,3.1904804 Z",
    fill: "inherit",
    id: "path-1-fast-forward" + unique
  }))));
};

FastForward.propTypes = propTypes;
var _default = FastForward;
exports["default"] = _default;